import { AudioTaskResponse, BotTasks } from "@apis:bot_tasks/bot_tasks";
import { callOrDefault } from "@utils:general";

export const botTaskAudioSelector = (data: BotTasks["GET"]["Response"]) => {
  const audioTaskResponse = callOrDefault(
    () => JSON.parse(data.statusMsg as string),
    {},
  ) as AudioTaskResponse;
  return {
    ...data,
    ...audioTaskResponse,
  };
};
